
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.242 10.503c2.643 0 4.785-2.127 4.785-4.752C15.027 3.127 12.886 1 10.242 1 7.599 1 5.456 3.127 5.456 5.751c0 2.625 2.143 4.752 4.786 4.752zM22.434 10.503c2.643 0 4.786-2.127 4.786-4.752C27.22 3.127 25.077 1 22.434 1s-4.786 2.127-4.786 4.751c0 2.625 2.143 4.752 4.786 4.752z","stroke":"#020203","stroke-width":".866","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M16.273 15.592a9.248 9.248 0 00-6.031-2.224C5.136 13.368 1 17.478 1 22.543c0 .154.005.303.01.457","stroke":"#020203","stroke-width":".866","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M31.665 23c.005-.149.01-.303.01-.457 0-5.069-4.14-9.175-9.241-9.175s-9.242 4.11-9.242 9.175c0 .154.005.303.01.457","stroke":"#020203","stroke-width":".866","stroke-miterlimit":"10","stroke-linecap":"round"}})])
          )
        }
      }
    